import { Controller } from "@hotwired/stimulus"

// Pokazuje/ukrywa pole "tag" w formularzu listy mailingowej zależnie od typu listy.
// Pole "tag" ma sens tylko gdy kind == "tag" (lista dynamiczna z klientów otagowanych w CRM).
// Initial state ustawia ERB klasą "hidden", JS przejmuje stan przy zmianie selecta.
export default class extends Controller {
  static targets = ["kindSelect", "tagField"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.tagFieldTarget.classList.toggle("hidden", this.kindSelectTarget.value !== "tag")
  }
}
